import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
    baseURL: API,
    withCredentials: true,
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("bao_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export default api;

export const CATEGORIES = [
    { slug: "thermos-flask-production-lines", name: "Thermos & Flask Production Lines" },
    { slug: "cup-printing-machines", name: "Cup Printing Machines" },
];

export const categoryName = (slug) =>
    CATEGORIES.find((c) => c.slug === slug)?.name || slug;
